module.exports = __webpack_public_path__ + "img/icon-close.878e12ad.svg";